import { NavLink } from "react-router";

export function ExperimentTabs() {
  return (
    <nav aria-label="Experiment tabs" className="flex gap-2 border-b pb-2">
      {[
        ["/experiments", "First-Echo paygate"],
        ["/experiments/h3-local", "H3 Local"],
      ].map(([to, label]) => (
        <NavLink
          key={to}
          end
          to={to}
          className={({ isActive }) =>
            `rounded-md px-3 py-2 text-sm ${isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"}`
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
